export default {
  props: {
    value: {
      type: Boolean,
      default: true
    },
    title: {
      type: String
    },
    hint: {
      type: String
    }
  },
  methods: {
    handleCancel() {
      this.$emit('input', false);
    }
  }
};